import {CssDimensionRestDto, PaddingRestDto} from "@/api/pharma-cms-content-page/models";
import {CssDimensionRestDtoModel} from "@/models/api/pharma-cms-content-page/CssDimensionRestDtoModel";

export class PaddingRestDtoModel implements PaddingRestDto {
    top?: CssDimensionRestDto | null;
    right?: CssDimensionRestDto | null;
    bottom?: CssDimensionRestDto | null;
    left?: CssDimensionRestDto | null;

    static createWithDefaults(): PaddingRestDtoModel {
        return new this(); // all sides absent
    }

    static cloneFrom(source: PaddingRestDto): PaddingRestDtoModel {
        const clone: PaddingRestDtoModel = new this();
        clone.top = source.top ? CssDimensionRestDtoModel.cloneFrom(source.top) : null;
        clone.right = source.right ? CssDimensionRestDtoModel.cloneFrom(source.right) : null;
        clone.bottom = source.bottom ? CssDimensionRestDtoModel.cloneFrom(source.bottom) : null;
        clone.left = source.left ? CssDimensionRestDtoModel.cloneFrom(source.left) : null;
        return clone;
    }
}
